import styled from '@emotion/styled';
import { alpha, MenuItem } from '@mui/material';

const DeleteMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.error.main,
  ':hover': {
    backgroundColor: alpha(theme.palette.error.main, 0.1),
  },
  ':focus': {
    backgroundColor: alpha(theme.palette.error.main, 0.2),
  },
}));

export default DeleteMenuItem;
